module.exports = "https://coursera_assets.s3.amazonaws.com/images/af7c59754b34d3d0b99c7040541a4558.png";